module.exports = __webpack_public_path__ + "static/media/a8.157105f7.png";